import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import copy from 'copy-to-clipboard';
import { useTranslation } from 'react-i18next';
import { IconCopy, IconDownload } from '../Icons';
import Link from '../Link';
import Button from '../Button';

const CallReport = ({ report }) => {
  const [copied, setCopied] = useState(false);
  const { t } = useTranslation('components');
  const [downloadUri, setDownloadUri] = useState(null);

  useEffect(() => {
    if (report) {
      URL.revokeObjectURL(downloadUri);
      setDownloadUri(
        URL.createObjectURL(
          new Blob([JSON.stringify(report, null, 2)], { type: 'application/json' }),
        ),
      );
    }
  }, [report]);

  const handleCopyClick = () => {
    copy(JSON.stringify(report, null, 2));
    setCopied(true);
  };

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (copied) {
      const timeout = setTimeout(() => {
        setCopied(false);
      }, 1000);
      return () => {
        clearTimeout(timeout);
      };
    }
  }, [copied]);

  return (
    <div className="flex flex-col justify-center h-full overflow-hidden">
      <div className="flex flex-col flex-1 min-h-0">
        <h1 className="font-semibold text-2xl mb-8 flex-shrink-0">{t('CallReport.title')}</h1>
        {report && (
          <div className="bg-slate-200 rounded mb-4 relative flex-1 min-h-0 flex">
            <pre className="overflow-auto flex-auto text-sm">{JSON.stringify(report, null, 2)}</pre>
          </div>
        )}
        <div className="flex flex-row justify-center lg:justify-end flex-wrap">
          <Link
            download="Systembericht.json"
            href={downloadUri || '#'}
            target="_blank"
            rel="noopener noreferrer"
            className="justify-center items-center py-2 px-4"
          >
            <IconDownload size="text" />
            <span className="ml-4">{t('CallReport.download')}</span>
          </Link>
          <Button
            className="justify-center py-2 px-4"
            kind="link"
            onClick={handleCopyClick}
            isDisabled={copied}
          >
            <IconCopy size="text" />
            <span className="ml-4">{copied ? t('CallReport.copied') : t('CallReport.copy')}</span>
          </Button>
        </div>
      </div>
    </div>
  );
};

CallReport.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  report: PropTypes.object,
};

export default CallReport;
